"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.FudaoPassportServiceErrorName = "FudaoPassportServiceError";
class FudaoPassportServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoPassportServiceError = FudaoPassportServiceError;
//# sourceMappingURL=IFudaoPassportService.js.map